/**
 * Onboarding & org-provisioning API client. Thin wrappers over the shared
 * `apiFetch` helper (see ./api) that map to the Elysia /onboarding module.
 *
 * `signup` is the public, unauthenticated org-creation call; on success the API
 * sets the session cookie, so the SPA can navigate straight into /app.
 */
import type {
  OrgSettings,
  SessionUser,
  SignupInput,
  SiteDto,
  NewSiteInput,
  UpdateOrgInput,
  UpdateSiteInput,
} from '@fc/core'
import { apiFetch } from './api'

export type {
  OrgSettings,
  OrgBranding,
  SignupInput,
  SiteDto,
  NewSiteInput,
  UpdateOrgInput,
  UpdateSiteInput,
} from '@fc/core'

// ---- Signup (public) ----
export const signup = (input: SignupInput) =>
  apiFetch<SessionUser>('/onboarding/signup', { method: 'POST', body: JSON.stringify(input) })

// ---- Org settings ----
export const getOrgSettings = () => apiFetch<OrgSettings>('/onboarding/org')

export const updateOrgSettings = (input: UpdateOrgInput) =>
  apiFetch<OrgSettings>('/onboarding/org', { method: 'PATCH', body: JSON.stringify(input) })

// ---- Sites ----
export const listSites = () => apiFetch<SiteDto[]>('/onboarding/sites')

export const createSite = (input: NewSiteInput) =>
  apiFetch<SiteDto>('/onboarding/sites', { method: 'POST', body: JSON.stringify(input) })

export const updateSite = (id: string, input: UpdateSiteInput) =>
  apiFetch<SiteDto>(`/onboarding/sites/${id}`, { method: 'PATCH', body: JSON.stringify(input) })

export const deleteSite = (id: string) =>
  apiFetch<void>(`/onboarding/sites/${id}`, { method: 'DELETE' })
